<template>
    <div class="QHfileList">
        <div class="li" v-for="(item, index) in values" v-bind:key="index">
            <p>{{ item.name }}</p>
            <span class="tool flex-center">
                <font @click="$QHopen.url($httpFile(item.url),1500)">查看</font>
            </span>
        </div>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        values: {
            type: [Array, String],
            default: ""
        }
    },
}
</script>
<style>
.QHfileList .li {
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;
    margin: 5px 0 !important;
    color: #444;
    font-size: 14px;
}

.QHfileList .li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.QHfileList .li .filebox {
    display: none;
}

.QHfileList .li p {
    display: block;
}

.QHfileList .li .tool {
    display: block !important;
    white-space: nowrap;
    word-break: keep-all;
}

.QHfileList .li .tool font {
    color: #3975C6;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
    word-break: keep-all;
    margin-left: 5px;
}

.QHfileList .li .tool font:hover {
    text-decoration: underline;
}
</style>